import { useQuery } from '@tanstack/react-query';
import type { Notification, NotificationStatus } from 'src/notifications/types/Notification';

const POLL_INTERVAL_MS = 5_000;

export function useNotifications({ status }: { status?: NotificationStatus } = {}) {
  return useQuery<Notification[]>({
    queryKey: status ? ['notifications', { status }] : ['notifications'],
    refetchInterval: POLL_INTERVAL_MS,
  });
}
